module.exports = __webpack_public_path__ + "static_pc/img/marqueeTitle.957f537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/marqueeTitle.png
// module id = MY3d
// module chunks = 1